import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    IconButton,
    Typography,
    InputLabel,
    FormControl,
    FormLabel,
    OutlinedInput
} from "@mui/material";
import { Close, } from "@mui/icons-material";
import TextareaAutosize from '@mui/material/TextareaAutosize';

const styles = {
  dialogContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    color: "#000",
    gap: "10px",
  },
  textColumn: {
    flexGrow: 1,
    textAlign: "justify",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "normal",
  },
  message: {
    fontSize: "1rem",
    textAlign: "justify",
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    gap: "20px",
  },
  cancelButton: {
    color: "#5A73EA",
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
  },
  okButton: {
    color: "#6b7280",
    backgroundColor: "#e2e6fb",
    border: "none",
    boxShadow: "none",
  },
};

export const JSExportDialog = ({
  openDialogBox,
  dialogContent,
  onCloseDialog,
  onConfirmDialog,
  validateEmails,
  onClearDialog,
  onResetDone
}) => {
  const [textContent, setTextContent] = useState("");
  const [enableOk, setEnableOk] = useState(false);

  useEffect(() => {
    if (onClearDialog) {
      //clear contents
      setTextContent("")
      setEnableOk(false)
      onResetDone() //tell parent to reset done
    }
    
  }, [onClearDialog])

  const handleContentOnChange = (e) => {
    // Removes any space including new line and returns comma delimited email ids as a string
    const cleanEmailString = e.target.value.replaceAll(';', ',').replace(/\s+/g, '').replace(/,+$/, '').toLowerCase()
    const flag = validateEmails(cleanEmailString)
    if (flag) {
      setEnableOk(true);
    }
    else {
      setEnableOk(false);
    }
      setTextContent(e.target.value);
  };

  return (
    <Dialog
      open={openDialogBox}
      onClose={onCloseDialog}
      PaperProps={{
        sx: {
        minWidth: 300,         // minimum width
        maxWidth: 700,         // maximum width
        width: "90%",          // fills 90% of viewport on small screens
        position: "fixed",
        top: "50%",            // vertical center
        right: "20px",         // 20px from right edge
        transform: "translateY(-50%)", // vertically center
        zIndex: 1000,
        }
      }}
    >
      <DialogTitle
        sx={{
            padding: "16px", // Add padding to the DialogTitle
            borderBottom: "1px solid #ccc",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography style={styles.title}>Export Documents</Typography>
          <IconButton onClick={onCloseDialog}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
          <DialogContent
          sx={{
            mt: 2, // Add top margin
        }}>
        <div style={styles.dialogContent}>
          <div style={styles.textColumn}>
            <Typography
              style={{
                ...styles.message,
                whiteSpace: "pre-wrap", // Wrap message content
                wordWrap: "break-word",
              }}
            >
              {dialogContent?.Message}
            </Typography>
            
            <TextField
            fullWidth
            multiline
            minRows={4}
            maxRows={10}
            value={textContent}
            onChange={handleContentOnChange}
            placeholder="email1@email.com, email2@email.com"
            label="Link Recipients"
            variant="outlined"
            sx={{
                "& .MuiOutlinedInput-root": {
                overflow: "hidden",          // prevents layout break
                },
                "& .MuiOutlinedInput-input": {
                overflowY: "auto",           // scroll inside textarea after maxRows
                padding: "8px 12px",         // optional: match Material look
                },
                "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#d3d3d3",      // light gray border
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#bcbcbc",      // hover state
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#a8a8a8",      // focused state
                },
                mt:2,
            }}
            />

          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div style={styles.actions}>
          <Button style={styles.cancelButton} onClick={onCloseDialog}>
            CANCEL
          </Button>
          <Button className= "ywButtonBlue" style={styles.okButton} onClick={() => onConfirmDialog(textContent)} disabled={!enableOk}>
            OK
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};